import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import { combineClasses } from 'wanderu-css';

import TableContext from './TableContext';

import styles from './Table.scss';

function Table(props) {
    const {
        classes: classesProps = {},
        className,
        component: ComponentProp = 'table',
        componentProps,
        children,
        orientation = 'vertical',
        variant = 'none',
        ...otherProps
    } = props;

    const classes = combineClasses(styles, classesProps);
    const context = React.useMemo(() => ({ orientation, variant }), [orientation, variant]);

    return (
        <TableContext.Provider value={context}>
            <ComponentProp
                className={clsx(
                    classes.root,
                    className,
                )}
                {...componentProps}
                {...otherProps}
            >
                {children}
            </ComponentProp>
        </TableContext.Provider>
    );
}

Table.propTypes = {
    children: PropTypes.node.isRequired,
    classes: PropTypes.object,
    className: PropTypes.string,
    component: PropTypes.elementType,
    componentProps: PropTypes.object,
    orientation: PropTypes.oneOf(['horizontal', 'vertical']),
    variant: PropTypes.oneOf(['dividers', 'blocks', 'none']),
};

export default Table;
